<h2 mat-dialog-title>Quick Links Search</h2>
<mat-dialog-content>
  <mat-form-field appearance="outline" class="search-field">
    <mat-label>Search quick links</mat-label>
    <input matInput [formControl]="searchControl" placeholder="Type to search..." autofocus>
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <div class="quick-links-list">
    <div *ngIf="(filteredQuickLinks | async)?.length === 0" class="no-results">
      No quick links found matching your search.
    </div>

    <div class="quick-link-item" *ngFor="let link of filteredQuickLinks | async" (click)="activateQuickLink(link)">
      <div class="quick-link-key">{{ link.key }}</div>
      <div class="quick-link-info">
        <mat-icon *ngIf="link.icon">{{ link.icon }}</mat-icon>
        <span>{{ link.description }}</span>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Close</button>
</mat-dialog-actions>
